import { useEffect, useState } from "react";

export function LeadsContactsDropdown({
  value,
  onChange,
  currentDealerEmail, // make sure this is passed from parent
}) {
  const [type, setType] = useState("");
  const [records, setRecords] = useState([]);
  const [recordValue, setRecordValue] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedModule, setSelectedModule] = useState("");
  const [selectedModuleRecord, setSelectedModuleRecord] = useState(null);
  const [moduleRecords, setModuleRecords] = useState([]);

  function handleTypeChange(e) {
    const selectedType = e.target.value;
    setType(selectedType);
    setRecordValue(null);
    setSearchTerm("");
    setRecords([]);
    setSelectedModule("");
    setModuleRecords([]);
    setSelectedModuleRecord(null);
    onChange(null);
  }

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (!searchTerm || searchTerm.length < 2 || !type) {
        setRecords([]);
        return;
      }

      const url =
        type === "Leads"
          ? "/server/dealer_backend/getLeadsSearch"
          : "/server/dealer_backend/getContactsSearch";

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          searchTerm,
          dealerEmail: currentDealerEmail,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          const options = (data?.data || []).map((item) => ({
            id: item.id,
            name: `${item.First_Name || ""} ${item.Last_Name || ""}`.trim(),
          }));
          setRecords(options);
        })
        .catch((err) => {
          console.error(err);
          setRecords([]);
        });
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, type, currentDealerEmail]);

  async function handleModuleChange(e) {
    const module = e.target.value;
    setSelectedModule(module);
    setSelectedModuleRecord(null);

    if (!module) {
      setModuleRecords([]);
      return;
    }

    const res = await fetch(
      `/server/dealer_backend/getRecords?module=${module}`
    );
    const json = await res.json();

    if (json.status === "success") {
      const options = json.data.map((item) => ({
        id: item.id,
        name:
          item.Name ||
          item.Deal_Name ||
          item.Account_Name ||
          item.Company ||
          item.Last_Name ||
          "Untitled",
      }));
      setModuleRecords(options);
    } else {
      setModuleRecords([]);
    }
  }

  function handleModuleRecordChange(e) {
    const id = e.target.value;
    const record = moduleRecords.find((r) => r.id === id);
    setSelectedModuleRecord(record);

    onChange({
      type: "Contacts",
      What_Id: record?.id || null,
      What_Name: record?.name || null,
      Who_Id: recordValue?.id || null,
      Who_Name: recordValue?.name || null,
      se_module: selectedModule || null,
    });
  }

  return (
    <div className="flex flex-col gap-2">
      {/* Type Selection */}
      <select
        value={type}
        onChange={handleTypeChange}
        className="border border-gray-300 p-2"
      >
        <option value="">Select Type</option>
        <option value="Leads">Potential Donor</option>
        <option value="Contacts">Existing Donor</option>
      </select>

      {/* Search Box */}
      {type && (
        <>
          <input
            type="text"
            placeholder="Search record by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-gray-300 p-2"
          />

          {records.length > 0 && (
            <ul className="border border-gray-300 max-h-40 overflow-y-auto bg-white rounded shadow">
              {records.map((rec) => (
                <li
                  key={rec.id}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    setRecordValue(rec);
                    setSearchTerm(rec.name);
                    setRecords([]);

                    if (type === "Leads") {
                      onChange({
                        type,
                        What_Id: rec.id,
                        What_Name: rec.name,
                        Who_Id: null,
                        Who_Name: null,
                        se_module: "Leads",
                      });
                    } else {
                      // only select contact, wait for module selection
                      onChange(null);
                    }
                  }}
                >
                  {rec.name}
                </li>
              ))}
            </ul>
          )}
        </>
      )}

      {/* Module Dropdown for Contacts */}
      {type === "Contacts" && recordValue && (
        <>
          <select
            value={selectedModule}
            onChange={handleModuleChange}
            className="border border-gray-300 p-2"
          >
            <option value="">Select Module</option>
            <option value="Accounts">Accounts</option>
            <option value="Deals">Deals</option>
            <option value="Cases">Cases</option>
            {/* Add more if needed */}
          </select>

          {selectedModule && moduleRecords.length > 0 && (
            <select
              value={selectedModuleRecord?.id || ""}
              onChange={handleModuleRecordChange}
              className="border border-gray-300 p-2"
            >
              <option value="">Select Record</option>
              {moduleRecords.map((rec) => (
                <option key={rec.id} value={rec.id}>
                  {rec.name}
                </option>
              ))}
            </select>
          )}
        </>
      )}
    </div>
  );
}

export default LeadsContactsDropdown;
